import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
// import { queryClient } from "App";
import { UpdatePaymentMethodType } from "types/PaymentTypes";
import { queryClient } from "App";

export const useUpdatePaymentMethod = (
  options?: UseMutationOptions<any, Error, UpdatePaymentMethodType>
) => {
  const toastId = `update-payment-method`;
  return useMutation({
    ...options,
    mutationKey: ["updatePaymentMethod"],
    mutationFn: async (id) => {
      return axiosInstance
        .put("/payment-methods", { id })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: toastId,
      });
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["paymentMethods"] });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      Toast({
        message: "Domyslna karta zmieniona pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: toastId,
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas zmiany domyslnej karty.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: toastId,
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdatePaymentMethod;
